import { render, staticRenderFns } from "./PassChangeV.vue?vue&type=template&id=5346eb4a"
import script from "./PassChangeV.vue?vue&type=script&lang=js"
export * from "./PassChangeV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports